
import {Vue, prop, Options} from "vue-class-component"
import { PusatResolusiV2Controller } from '@/app/ui/controllers/PusatResolusiV2Controller';
import { SubmitNotePusatResolusiRequest } from '@/data/payload/api/PusatResolusiV2ApiRequest';
import { MainAppController } from '@/app/ui/controllers/MainAppController';
import { parsingErrorResponse } from '@/app/infrastructures/misc/Utils';
import LpInput from "@/app/ui/components/lp-input/index.vue";

class Props {
  modelValue = prop<string>({
    type: String,
    required: true
  });
}

@Options({
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal: string) {
        this.$nextTick(() => {
          this.resizeTextarea();
        });
      }
    }
  },
  components: {
    LpInput
  }
})

export default class Note extends Vue.with(Props) {
  loading = false;

  mounted() {
    this.resizeTextarea();
  }
  get noteModel() {
    return this.modelValue;
  }

  set noteModel(val: string) {
    this.$emit("update:modelValue", val);
  }

  get isSubmitButtonDisabled() {
    return !this.modelValue.length
  }

  resizeTextarea() {
    const textarea: any = document.getElementById("pusat-resolusi-v2-detail-note");
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = (textarea.scrollHeight < 39 ? 39 : textarea.scrollHeight) + "px";
  }

  async onSubmit() {
    if (this.isSubmitButtonDisabled) return;
    try {
      this.loading = true;
      await PusatResolusiV2Controller.submitNote(new SubmitNotePusatResolusiRequest({
        note: this.noteModel,
        id: Number(this.$route.params.id)
      }))
    } catch(err) {
      MainAppController.showErrorMessage(parsingErrorResponse(err, this.$t('pusatResolusi.failedToSaveNote')))
    } finally {
      this.loading = false;
    }
  }
}
